import React, { useEffect } from "react";
import FetchData from "../../components/fetchData/FetchData";
import Slider from "../../components/slider/Slider";
import Advert from "../../components/advert/Advert";
import SlickSlider from "../../components/slider/SlickSlider";
import Advert2 from "../../components/advert/Advert2";
import Info from "../../components/info/Info";
import { useDispatch, useSelector } from "react-redux";
import { clickPaymentButton } from "../../redux/feature/paymentReducer";

const Home = () => {
  const dispatch = useDispatch();

  const clickPaymentBtn = useSelector(
    (state) => state.paymentButton.clickPaymentButton
  );
  useEffect(() => {
    if (window.location.pathname === "/payment") {
      dispatch(clickPaymentButton(true));
    } else {
      dispatch(clickPaymentButton(false));
    }
  }, [clickPaymentBtn]);
  return (
    <div>
      <Slider />
      <Advert />
      <Info />
      <Advert2 />
      <FetchData />
      <SlickSlider />
    </div>
  );
};

export default Home;
